import { render, staticRenderFns } from "./PPMReports.vue?vue&type=template&id=bb41a95e&scoped=true&"
import script from "./PPMReports.vue?vue&type=script&lang=ts&"
export * from "./PPMReports.vue?vue&type=script&lang=ts&"
import style0 from "./PPMReports.vue?vue&type=style&index=0&lang=css&"
import style1 from "./PPMReports.vue?vue&type=style&index=1&id=bb41a95e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb41a95e",
  null
  
)

component.options.__file = "PPMReports.vue"
export default component.exports